/**
 * @module ui/skip-link-primary
 */

let skipLink;
let targetElement;

/**
 * @method skipLinkPrimaryInit
 * @description Initializes the skip link by adding a click listener
 */
export default function skipLinkPrimaryInit() {
  skipLink = document.querySelector(".c-skip-link--primary");
  if (!skipLink) {
    return;
  }
  skipLink.addEventListener("click", onClick);
}

/**
 * @method setTarget
 * @description Overrides the default link target with some other element. Set this to null to use the anchor specified in the link's href attribute.
 * @param {HTMLElement} el
 */
export function setTarget(el) {
  targetElement = el;
}

/**
 * @method onClick
 * @description Sets focus to the target element when the skip link is activate
 * @param {MouseEvent} event
 */
function onClick(event) {
  // Without preventDefault, element blurs immediately after receiving focus
  event.preventDefault();
  // Unless the link target has been overridden, jump to the href anchor
  if (!targetElement) {
    const targetId = skipLink.getAttribute("href");
    targetElement = document.querySelector(targetId);
  }
  if (!targetElement) {
    return;
  }
  // According to WebAIM.org: "Some browsers do not fully support in-page
  // links. While they may visually shift focus to the location of the target
  // or named anchor for the "skip" link, they do not actually set keyboard
  // focus to this location. These bugs can potentially be addressed by using
  // JavaScript to set focus to the target element." See:
  // https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/
  targetElement.focus();
}
